import { useEffect, useState } from "react";

import { clearMfaLoginMarker } from "features/login/services/session";

const IMAGES = [
  "/static/login/1.png",
  "/static/login/2.png",
  "/static/login/3.png",
  "/static/login/4.png",
  "/static/login/5.png",
] as const;

export function useLoginCarousel(): {
  active: number;
  images: readonly string[];
} {
  const [active, setActive] = useState(1);

  useEffect(() => {
    clearMfaLoginMarker();
    const id = window.setInterval(() => {
      setActive((prev) => (prev === IMAGES.length ? 1 : prev + 1));
    }, 4000);
    return () => window.clearInterval(id);
  }, []);

  return { active, images: IMAGES };
}
